// Modules
import React, { useEffect } from 'react'
import { Modal, Button } from '@dasa-health/components-react'
import { useTracking } from 'react-tracking'

// Components
import { ModalContainer, ModalImg, ModalContent, ModalWrapper } from './styles'
import { goToPage } from 'redesign/utils/goToPage'

export interface AccountExistsModalProps {
    showModal: boolean
    setShowModal: React.Dispatch<React.SetStateAction<boolean>>
    image: string
    title: string
    subtitle: string
    link: {
        to: string
        text: string
    }
    trackEvent?: {
        event: string
        steps: string
        path?: string
    }
}

export const AccountExistsModal: React.FC<AccountExistsModalProps> = props => {
    const { trackEvent: track } = useTracking()
    const { showModal, setShowModal, image, title, subtitle, link, trackEvent } = props

    useEffect(() => {
        if (trackEvent) {
            track(trackEvent)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    function NextPage() {
        setShowModal(false)
        goToPage(link.to)
    }

    return (
        <ModalContainer>
            <Modal fullMobile={true} onClose={() => setShowModal(false)} open={showModal}>
                <ModalWrapper>
                    <ModalImg alt="exclamação" src={image} />
                    <ModalContent>
                        <h1 className="modal__title">{title}</h1>
                        <p className="modal__subtitle">{subtitle}</p>

                        <Button data-testid="account-exists-modal-button" onClick={NextPage} variant="primary">
                            {link?.text}
                        </Button>
                    </ModalContent>
                </ModalWrapper>
            </Modal>
        </ModalContainer>
    )
}
